// Turkish-aware text formatting helpers.
// Uses the tr-TR locale so dotted/dotless i casing works correctly (ı→I, i→İ).
export function trTitleCase(str) {
	if (!str) return str;
	return str
		.toLocaleLowerCase("tr-TR")
		.replace(/(^|\s)(\S)/g, (m, sep, ch) => sep + ch.toLocaleUpperCase("tr-TR"));
}
